import { menuItemsUrl } from './resources.js'
import common from './common.js'

async function getMenuItemsByMenu(menuid) {
    let url = `${menuItemsUrl}/get/${menuid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => { 
                    data = response });
    return data;
}



export default {
    name: 'menusService',
    getMenuItemsByMenu,
    
}